import type { ReactNode } from 'react';
import { Skeleton } from '@monksflow/monks-ui';

interface PendingSkeletonProps {
  /** While true the children are covered by a placeholder of their own size. */
  pending?: boolean;
  className?: string;
  children: ReactNode;
}

/**
 * Covers a group of controls with a placeholder while the section loads.
 *
 * The children stay mounted and invisible inside it, so the placeholder is
 * exactly their size — no hand-matched width or height to keep in step when a
 * control is added, and no inset of its own to disagree with the toolbar's.
 */
export function PendingSkeleton(props: PendingSkeletonProps) {
  if (!props.pending) return <>{props.children}</>;

  return (
    <Skeleton className={props.className} data-testid="pending-skeleton">
      <div className="invisible" aria-hidden inert>
        {props.children}
      </div>
    </Skeleton>
  );
}
